import { render, staticRenderFns } from "./sales-row.vue?vue&type=template&id=534697f3&scoped=true&"
import script from "./sales-row.vue?vue&type=script&lang=js&"
export * from "./sales-row.vue?vue&type=script&lang=js&"
import style0 from "./sales-row.vue?vue&type=style&index=0&id=534697f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534697f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VLayout,VSpacer})
